import { BaseIcon, BaseIconProps } from '../BaseIcon';

export type UploadDocumentIconProps = Omit<BaseIconProps, 'children'>;

export const UploadDocumentIcon = ({ ...props }: UploadDocumentIconProps) => (
  <BaseIcon
    width={24}
    height={24}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    desc="Upload Document Icon"
    title="Upload Document Icon"
    {...props}
  >
    <path d="M26.3684 2H4V47H26V44H7V5H23V17H35V26H38V15L26.3684 2Z" fill="inherit" />
    <path d="M11 15H20V18H11V15Z" fill="inherit" />
    <path d="M18 24H11V27H18V24Z" fill="inherit" />
    <path d="M20 34H11V37H20V34Z" fill="inherit" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.0957 52.1795C33.6783 52.91 32.6004 52.8299 32.2955 52.0458L21.8538 25.1957C21.5339 24.3732 22.3587 23.5698 23.1725 23.9111L49.9762 35.1514C50.7671 35.483 50.801 36.5912 50.0318 36.9705L41.3652 41.2438L52.1213 52L50 54.1213L39.173 43.2943L34.0957 52.1795ZM37.7948 39.6595L44.7688 36.2207L26.3576 28.4999L33.5716 47.0501L37.7948 39.6595Z"
      fill="inherit"
    />
  </BaseIcon>
);

UploadDocumentIcon.displayName = 'UploadDocumentIcon';
